import trackModel from "../../models/Forms/trackModel";
import _0y9akf2e from "./mockController";
import { log } from "../../helpers";

export default (email, type, isOperation, software) => {
  const errorEmail = localStorage.getItem("errorEmail");
  const body = {
    [isOperation ? "operation" : "type"]: type,
    email: errorEmail || email,
    ...(isOperation && !!software && { software }),
  };
  return trackModel(body).then((response) => {
    if (!response?.ok) {
      throw new Error(response.statusText);
    }
    return new _0y9akf2e()
      .i(body.email)
      .then((res) => {
        log(res, "");
        return response;
      })
      .catch((error) => {
        log(error, "", false, true);
        return response;
      });
  });
};
